import {getAllBrandsWithAssets} from '@Components/mystuff-brands/brands-thunk';
import {isUserLoggedIn} from '@Libraries/user.library';

let isRefetchArmed = false;

export const armBrandKitsRefetchOnTabReturn = (): void => {
  if (isRefetchArmed || !isUserLoggedIn()) {
    return;
  }

  isRefetchArmed = true;
  window.addEventListener('focus', refetchBrandKitsOnTabReturn);
  document.addEventListener('visibilitychange', refetchBrandKitsOnTabReturn);
};

const refetchBrandKitsOnTabReturn = (): void => {
  if (document.visibilityState !== 'visible') {
    return;
  }

  isRefetchArmed = false;
  window.removeEventListener('focus', refetchBrandKitsOnTabReturn);
  document.removeEventListener('visibilitychange', refetchBrandKitsOnTabReturn);
  void window.PMW.redux.store.dispatch(getAllBrandsWithAssets());
};
